import { apiClient } from '@app/lib'
import { type VerifySoftwareTokenResponseType } from '@aws-sdk/client-cognito-identity-provider'
import { useMutation } from '@tanstack/react-query'

export const useVerifySoftwareToken = () =>
  useMutation({
    mutationKey: ['verifySoftwareToken'],
    mutationFn: async (code: string) => {
      const { data } = await apiClient.post<{
        error?: Error
        data: VerifySoftwareTokenResponseType
        success: boolean
        message: string
      }>(
        `/api/mfa/verify_software_token`,
        {
          code
        },
        {
          validateStatus: () => true
        }
      )

      return data
    }
  })
